<template>
  <v-container fluid id="appSupportRequests" class="pa-0 pa-sm-3">
    <v-dialog v-model="viewDialog" max-width="600">
      <v-card v-if="currentItem">
        <v-card-title primary-title>
          App Support Request
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pl-0">
                    <strong>Category</strong>
                  </td>
                  <td>
                    {{ currentItem.requestCategory }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Subject</strong>
                  </td>
                  <td>
                    {{ currentItem.subject }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Description</strong>
                  </td>
                  <td>
                    {{ currentItem.description }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Notes</strong>
                  </td>
                  <td>
                    <div
                      v-for="note in currentItem.notes"
                      :key="note.createDate"
                      style="background: #f4f4f4;padding: 5px 8px;margin: 5px 0;border: solid 1px #cdcdcd;border-radius: 5px;"
                    >
                      {{ note.message }}<br />
                      <span class="caption grey--text">
                        <em>
                          {{ note.createdBy.name }} on
                          {{
                            note.createDate | moment("MMM D YYYY [at] h:mma")
                          }}</em
                        ></span
                      ><br />
                    </div>
                    <v-textarea
                      label="Add Note"
                      outlined
                      class="mt-2 mb-2"
                      hide-details
                      v-model="currentItem.message"
                      v-if="currentItem.status === 'open'"
                    ></v-textarea>
                    <v-container
                      fluid
                      class="pa-0 ma-0"
                      v-if="currentItem.status === 'open'"
                    >
                      <v-layout wrap class="pa-0 ma-0">
                        <v-row class="pa-0 ma-0">
                          <v-col
                            class="pa-0 ma-0"
                            style="vertical-align:top;max-width:110px !important"
                          >
                            <v-btn
                              v-if="currentItem.status === 'open'"
                              color="primary"
                              small
                              @click="saveNote"
                              :disabled="!currentItem.message"
                              >Save Note</v-btn
                            >
                          </v-col>
                          <v-col class="pa-0 ma-0" style="vertical-align:top">
                            <v-checkbox
                              style="margin-top: -2px;"
                              color="primary"
                              small
                              label="Send Email?"
                              v-model="currentItem.sendEmail"
                              :value="false"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-layout>
                    </v-container>
                  </td>
                </tr>

                <tr v-if="currentItem.status === 'closed'">
                  <td class="pl-0">
                    <strong>Final Note</strong>
                  </td>
                  <td>
                    {{ currentItem.closingNote }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="viewDialog = false" class="mr-2"
            >cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="closeDialog" max-width="600">
      <v-card v-if="currentItem">
        <v-card-title primary-title>
          App Support Request
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td class="pl-0">
                    <strong>Category</strong>
                  </td>
                  <td>
                    {{ currentItem.requestCategory }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Subject</strong>
                  </td>
                  <td>
                    {{ currentItem.subject }}
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Description</strong>
                  </td>
                  <td>
                    {{ currentItem.description }}
                  </td>
                </tr>
                <tr v-if="currentItem.notes.length">
                  <td class="pl-0">
                    <strong>Notes</strong>
                  </td>
                  <td>
                    <div
                      v-for="note in currentItem.notes"
                      :key="note.createDate"
                      style="background: #f4f4f4;padding: 5px 8px;margin: 5px 0;border: solid 1px #cdcdcd;border-radius: 5px;"
                    >
                      {{ note.message }}<br />
                      <span class="caption grey--text">
                        <em>
                          {{ note.createdBy.name }} on
                          {{
                            note.createDate | moment("MMM D YYYY [at] h:mma")
                          }}</em
                        ></span
                      ><br />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="pl-0">
                    <strong>Closing Note</strong>
                  </td>
                  <td>
                    <v-textarea
                      label="Closing Note"
                      outlined
                      class="mt-2 mb-2"
                      hide-details
                      v-model="currentItem.closingNote"
                    ></v-textarea>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDialog = false" class="mr-2"
            >cancel</v-btn
          >
          <v-btn @click="closeRequest" class="error mr-2">Close Request</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="priorityDialog" max-width="400">
      <v-card v-if="currentItem">
        <v-card-title primary-title>
          Change Priority
        </v-card-title>
        <v-card-text>
          SUBJECT: <strong>{{ currentItem.subject }}</strong> <br /><br />
          Current Priority: <strong>{{ this.currentItem.priority }}</strong
          ><br /><br />
          Set new priority:
          <v-select
            :items="['none', 'medium', 'high']"
            v-model="currentItem.priorityValue"
            dense
            outlined
          ></v-select>
        </v-card-text>
        <v-card-actions class="align-right pa-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="priorityDialog = false"
            class="mr-2"
            >cancel</v-btn
          >
          <v-btn @click="changePriority" class="primary mr-2">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        App Support Requests - Admin View
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="appSupportRequestType('open')">Open</v-tab>
            <v-tab @click="appSupportRequestType('closed')">Closed</v-tab>
            <v-tab @click="appSupportRequestType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentAppSupportRequests"
            :loading="loadingAppSupportRequests"
            loading-text="Loading....please wait."
            :headers="headers"
            :items-per-page="100"
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.orderedBy="{ item }">
              {{ item.orderedBy.firstName }}
              {{ item.orderedBy.lastName[0] }}.<br />
              <span class="caption grey--text">{{
                item.orderDate.toDate() | moment("M/D/YYYY")
              }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template v-slot:item.priority="{ item }">
              <v-chip v-if="item.priority == 'high'" small color="error"
                >High</v-chip
              >
              <v-chip v-if="item.priority == 'medium'" small color="amber"
                >Medium</v-chip
              >
              <v-chip v-if="item.priority == 'none'" small>None</v-chip>
            </template>
            <template v-slot:item.description="{ item }">
              <div>
                <strong>{{ item.subject }}</strong>
              </div>
              <div>
                {{
                  item.description.substring(
                    0,
                    Math.min(220, item.description.length)
                  )
                }}<span v-if="item.description.length > 220"
                  >...<span
                    class="blue--text"
                    style="cursor:pointer"
                    @click="openDialog(item, 'viewDialog')"
                    >more</span
                  ></span
                >
              </div>
            </template>
            <template v-slot:item.notes="{ item }">
              <div v-for="(note, ix) in item.notes" :key="note.createDate">
                <div v-if="ix == item.notes.length - 1 && !item.closingNote">
                  {{ note.message }}
                  <span class="caption grey--text">
                    by {{ note.createdBy.name }} on
                    {{
                      note.createDate | moment("MMM D YYYY [at] h:mma")
                    }}</span
                  >
                </div>
              </div>
              <span v-if="item.closingNote">
                <v-icon small style="margin-top:-3px" class="mr-1"
                  >check_box</v-icon
                >{{ item.closingNote }}<br />
                <span class="caption grey--text">
                  on
                  {{
                    item.closeDate &&
                      item.closeDate.toDate() | moment("MMM D YYYY [at] h:mma")
                  }}
                </span>
              </span>
            </template>
            <template v-slot:item.view="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                class="mr-2"
                @click="openDialog(item, 'viewDialog')"
                >view</v-btn
              >
              <v-btn
                v-if="item.status === 'open'"
                color="primary"
                small
                outlined
                text
                class="mr-2"
                @click="openDialog(item, 'priorityDialog')"
                >priority</v-btn
              >
              <v-btn
                v-if="item.status === 'open'"
                color="primary"
                small
                outlined
                text
                @click="openDialog(item, 'closeDialog')"
                >close</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import statusChip from "@/components/StatusChip";
import firebase from "firebase/app";
import moment from "moment";
import { orderBy } from "lodash";
export default {
  components: {
    statusChip,
  },
  data() {
    return {
      type: "open",
      loadingAppSupportRequests: true,
      appSupportRequests: [],
      currentItem: null,
      viewDialog: false,
      closeDialog: false,
      priorityDialog: false,
      headers: [
        {
          text: "#",
          align: "left",
          value: "orderNumber",
          width: 60,
        },
        {
          text: "Requestor",
          value: "orderedBy",
          width: "100",
          sort: (a, b) => {
            const nameA = `${a.firstName} ${a.lastName}`.toLowerCase();
            const nameB = `${b.firstName} ${b.lastName}`.toLowerCase();
            return nameA.localeCompare(nameB);
          },
        },
        { text: "Category", value: "requestCategory", width: 140 },
        {
          text: "Description",
          value: "description",
          sort: (a, b) => {
            return (a || "").toLowerCase().localeCompare((b || "").toLowerCase());
          },
        },
        { text: "Latest Note", value: "notes", sortable: false },
        { text: "Status", value: "status", align: "center", width: 100 },
        {
          text: "Priority",
          value: "priority",
          align: "center",
          width: 100,
          sort: (a, b) => {
            const order = { high: 0, medium: 1, none: 2 };
            const rank = (v) => (order[v] === undefined ? 3 : order[v]);
            return rank(a) - rank(b);
          },
        },
        { text: "", value: "view", align: "right", width: 280, sortable: false },
      ],
    };
  },
  computed: {
    currentAppSupportRequests: function() {
      if (this.type === "closed") {
        return orderBy(
          this.appSupportRequests.filter((wo) => wo.status == this.type),
          ["closeDate"],
          ["desc"]
        );
      }
      return orderBy(
        this.appSupportRequests.filter((wo) => wo.status == this.type),
        ["priority"],
        ["asc"]
      );
    },
    ...mapState(["user"]),
  },
  async created() {
    this.getAppSupportRequests();
  },
  methods: {
    async getAppSupportRequests() {
      try {
        const res = await fb.db
          .collection("appSupportRequests")
          .orderBy("orderDate", "desc")
          .limit(300)
          .get();
        const appSupportRequests = [];
        res.forEach((u) => {
          appSupportRequests.push({
            ...u.data(),
          });
        });
        this.appSupportRequests = orderBy(
          appSupportRequests,
          ["priority"],
          ["asc"]
        );
        this.loadingAppSupportRequests = false;
      } catch (error) {
        alert(error);
        console.log(error);
        this.loadingAppSupportRequests = false;
      }
    },
    appSupportRequestType(type) {
      this.type = type;
    },
    openDialog(item, dialog) {
      this.currentItem = item;
      this[dialog] = true;
    },
    async saveNote() {
      await fb.db
        .collection("appSupportRequests")
        .doc(this.currentItem.orderNumber)
        .update({
          notes: firebase.firestore.FieldValue.arrayUnion({
            message: this.currentItem.message,
            createdBy: {
              name: `${this.user.firstName} ${this.user.lastName}`,
              email: `${this.user.email}`,
            },
            createDate: moment().unix(),
          }),
        });
      this.viewDialog = false;
      this.getAppSupportRequests();
    },
    async closeRequest() {
      await fb.db
        .collection("appSupportRequests")
        .doc(this.currentItem.orderNumber)
        .update({
          closingNote: this.currentItem.closingNote,
          status: "closed",
          closedBy: {
            name: `${this.user.firstName} ${this.user.lastName}`,
            email: `${this.user.email}`,
          },
          closeDate: fb.timestamp,
        });
      this.closeDialog = false;
      this.getAppSupportRequests();
    },
    async changePriority() {
      await fb.db
        .collection("appSupportRequests")
        .doc(this.currentItem.orderNumber)
        .update({
          priority: this.currentItem.priorityValue,
        });
      this.priorityDialog = false;
      this.getAppSupportRequests();
    },
  },
};
</script>
